import { render, staticRenderFns } from "./ProductionTimeHistoryTable.vue?vue&type=template&id=617f2bf0&scoped=true&"
import script from "./ProductionTimeHistoryTable.vue?vue&type=script&lang=ts&"
export * from "./ProductionTimeHistoryTable.vue?vue&type=script&lang=ts&"
import style0 from "./ProductionTimeHistoryTable.vue?vue&type=style&index=0&id=617f2bf0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617f2bf0",
  null
  
)

export default component.exports